export default "__VITE_ASSET__CwcmU7iX__"